import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import LoadingSpinner from './LoadingSpinner';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading, isSuperAdmin, user } = useAuth();
  const location = useLocation();

  if (loading) {
    return <LoadingSpinner text="Verifying session..." />;
  }

  const isSuperAdminPath = location.pathname.startsWith('/superadmin') || location.pathname.startsWith('/settings/control-tower');

  if (!isAuthenticated) {
    const targetLogin = isSuperAdminPath ? '/superadmin/login' : '/login';
    return <Navigate to={targetLogin} state={{ from: location }} replace />;
  }

  if (isSuperAdminPath) {
    const isSuperUser = Boolean(
      isSuperAdmin ||
      user?.type === 'SuperAdmin' ||
      user?.email === 'connect@sanglob.com' ||
      user?.email === 'superadmin@sanglob.local' ||
      (Array.isArray(user?.role) && user.role.includes('SuperAdmin')) ||
      (Array.isArray(user?.roles) && user.roles.some((r) => (r.name || r) === 'SuperAdmin'))
    );

    if (!isSuperUser) {
      return <Navigate to="/superadmin/login" state={{ from: location }} replace />;
    }
  }

  return children;
};

export default ProtectedRoute;
